<template>
    <div>
        <h2>ช่องทางการชำระ > ตั้งค่าการชำระเงินผ่านบัตรเครดิต/QR</h2>

        <div>
          <v-btn-toggle
            v-model="selectedPage"
            tile
            color="primary"
            group
          >
            <v-btn value="bank" @click="$router.push({ name: 'payment' })">
              โอนผ่านบัญชีธนาคาร
            </v-btn>

            <v-btn value="gbp" @click="$router.push({ name: 'payment_gbp' })">
              บัตรเครดิต/ผ่อน/QR
            </v-btn>            
          </v-btn-toggle>
        </div>  

        <v-form v-model="isGBFormValid">
          <v-card class="mt-4">            
            <v-card-title>ตั้งค่าการชำระเงินผ่านบัตรเครดิตด้วย GB Prime Pay Co.,Ltd</v-card-title>
            <v-card-subtitle>ยังไม่มีบัญชีกับ GB Prime Pay ? เปิดบัญชีใหม่</v-card-subtitle>
            
            <div class="pa-6">
              <v-row>
                <v-col cols="12" md="6">
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="gbFormData.GBPay_public_key"
                                outlined
                                label="Public Key *"                               
                                :rules="[validators.required]"
                                hide-details="auto"          
                                dense  
                            ></v-text-field>
                        </v-col>
                    </v-row>   
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="gbFormData.GBPay_secret_key"
                                outlined
                                label="Secret Key *"                               
                                :rules="[validators.required]"
                                hide-details="auto"          
                                dense  
                                type="password"
                            ></v-text-field>
                        </v-col>
                    </v-row>                 
                </v-col>
                <v-col cols="12" md="6">
                    <!-- VISA INFO -->
                    <v-img src="@/bulitInImages/paymentcard.svg"></v-img>
                </v-col>
              </v-row>
            </div>

            <v-card-actions>              
              <v-btn
                color="primary"               
                large          
                :disabled="!isGBFormValid"
                :loading="sendingData"
                @click="submitKey"
              >
                แก้ไข
              </v-btn>

              <v-btn
                color="secondary"               
                outlined                 
                large
                :disabled="sendingData"
                @click="$router.go(-1)"
              >
                กลับ
              </v-btn>                
            </v-card-actions>
          </v-card>   
        </v-form>

        <v-form v-model="isCreditFormValid">
          <v-card class="mt-4">            
            <v-card-title>
              <v-switch
                v-model="creditFormData.is_credit_allowed"                
              ></v-switch>
              <label for="">บัตรเครดิต/เดบิต</label>
            </v-card-title>
            <v-card-subtitle style="margin-top: -35px;">ตั้งค่าเฉพาะ การจ่ายเงินด้วบบัตรเครดิต</v-card-subtitle>
            
            <div class="px-6 py-2" v-if="creditFormData.is_credit_allowed">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model.number="creditFormData.GBPay_credit_min"
                      outlined
                      label="ยอดสั่งซื้อขั้นต่ำ *"                               
                      :rules="[validators.required, validators.minValueValidator(creditFormData.GBPay_credit_min, 0)]"                                
                      dense
                      hint="ต้องสั่งซื้อเกินยอดที่กำหนด ถึงจะชำระผ่านทางช่องทางนี้ได้; 0 คือ ไม่มีขั้นต่ำ"
                      persistent-hint
                  ></v-text-field>
                </v-col>                
              </v-row>              
              <v-row no-gutters>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div class="black--text">
                    ผู้รับผิดชอบค่าธรรมเนียม
                  </div>                  
                  <v-radio-group
                    v-model="creditFormData.GBPay_credit_fee_absorption"
                    row
                    class="ml-2"
                  >
                    <v-radio
                      label="เรา"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      label="ลูกค้า"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="!creditFormData.GBPay_credit_fee_absorption">
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model.number="creditFormData.GBPay_credit_fee_rate"
                      outlined
                      label="ค่าธรรมเนียม (%) *"                               
                      :rules="[
                        validators.required, 
                        validators.minValueValidator(creditFormData.GBPay_credit_fee_rate, 0),
                        validators.maxValueValidator(creditFormData.GBPay_credit_fee_rate, 99.99)
                      ]"                                
                      dense
                      persistent-hint
                  ></v-text-field>
                </v-col>                
              </v-row>
            </div>

            <v-card-actions>              
              <v-btn
                color="primary"               
                large          
                :disabled="!isCreditFormValid"
                :loading="sendingData"
                @click="submitCredit"                
              >
                แก้ไข
              </v-btn>

              <v-btn
                color="secondary"               
                outlined                 
                large
                :disabled="sendingData"
                @click="$router.go(-1)"
              >
                กลับ
              </v-btn>                
            </v-card-actions>
          </v-card>   
        </v-form>

        <v-form v-model="isInstallmentFormValid">
          <v-card class="mt-4">            
            <v-card-title>
              <v-switch
                v-model="installmentFormData.is_installmentable"                
              ></v-switch>
              <label for="">ผ่อนชำระ</label>
            </v-card-title>
            <v-card-subtitle style="margin-top: -35px;">ตั้งค่าเฉพาะ การจ่ายเงินแบบผ่อนชำระ</v-card-subtitle>
            
            <div class="px-6 py-2" v-if="installmentFormData.is_installmentable">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                      v-model.number="installmentFormData.installment_min"
                      outlined
                      label="ยอดสั่งซื้อขั้นต่ำ *"                               
                      :rules="[validators.required, validators.minValueValidator(installmentFormData.installment_min, 0)]"                                
                      dense
                      hint="ต้องสั่งซื้อเกินยอดที่กำหนด ถึงจะชำระผ่านทางช่องทางนี้ได้; 0 คือ ไม่มีขั้นต่ำ"
                      persistent-hint
                  ></v-text-field>
                </v-col>                
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div class="black--text">
                    ผู้รับผิดชอบค่าธรรมเนียม
                  </div>                  
                  <v-radio-group
                    v-model="installmentFormData.GBPay_installment_fee_absorption"
                    row
                    class="ml-2"
                  >
                    <v-radio
                      label="เรา"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      label="ลูกค้า"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <installmenttableVue
                  v-model="installmentFormData.banks"
                  ></installmenttableVue>
                </v-col>
              </v-row>
            </div>

            <v-card-actions>              
              <v-btn
                color="primary"               
                large          
                :disabled="!isInstallmentFormValid"
                :loading="sendingData"
                @click="submitInstallment"                
              >
                แก้ไข
              </v-btn>

              <v-btn
                color="secondary"               
                outlined                 
                large
                :disabled="sendingData"
                @click="$router.go(-1)"
              >
                กลับ
              </v-btn>                
            </v-card-actions>
          </v-card>   
        </v-form>
    </div>
</template>
<script>
import { maxLengthValidator, maxValueValidator, minValueValidator, required } from '@/@core/utils/validation'
import { asyncGet, asyncUpdate, asyncUpdateAsJson } from '@/helpers/asyncAxios'
import installmenttableVue from './components/installmenttable.vue'
export default {
  data() {
    return {
      selectedPage: 'gbp',
      sendingData: false,
      isGBFormValid: false,
      gbFormData: {
        GBPay_public_key: null,
        GBPay_secret_key: null,
      },
      isCreditFormValid: false,
      creditFormData: {
        is_credit_allowed: false,
        GBPay_credit_min: 0,
        GBPay_credit_fee_rate: 0,
        GBPay_credit_fee_absorption: true,
      },
      isInstallmentFormValid: false,
      installmentFormData: {
        is_installmentable: false,
        installment_min: 0,
        GBPay_installment_fee_absorption: true,
        banks: [],
      },
      validators: {
        maxLengthValidator,
        required,
        minValueValidator,
        maxValueValidator,
      },
    }
  },
  async created() {
    this.$store.commit('app/SET_GLOBAL_LOADING', true)
    try {
      const {
        GBPay_credit_fee_absorption,
        GBPay_installment_fee_absorption,
        GBPay_credit_fee_rate,
        GBPay_credit_min,
        GBPay_public_key,
        GBPay_secret_key,
        banks,
        is_installmentable,
        is_credit_allowed,
        installment_min,
      } = await asyncGet('/setting/payment/gbp')

      this.gbFormData = {
        GBPay_public_key: GBPay_public_key,
        GBPay_secret_key: GBPay_secret_key,
      }

      this.creditFormData = {
        is_credit_allowed: !!is_credit_allowed,
        GBPay_credit_min: GBPay_credit_min,
        GBPay_credit_fee_rate: GBPay_credit_fee_rate,
        GBPay_credit_fee_absorption: !!GBPay_credit_fee_absorption,
      }

      this.installmentFormData = {
        is_installmentable: !!is_installmentable,
        installment_min: installment_min,
        GBPay_installment_fee_absorption: !!GBPay_installment_fee_absorption,
        banks: banks,
      }
    } catch (error) {
      this.$root.showCommonDialog('มีปัญหา', error)
    }
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  methods: {
    async submitKey() {
      this.sendingData = true
      try {
        await asyncUpdate('/setting/payment/gbp/key', this.gbFormData)
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }

      this.sendingData = false
    },
    async submitCredit() {
      this.sendingData = true
      try {
        await asyncUpdate('/setting/payment/gbp/credit', this.creditFormData)
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }

      this.sendingData = false
    },
    async submitInstallment() {
      this.sendingData = true
      try {
        console.log(this.installmentFormData)
        await asyncUpdateAsJson('/setting/payment/gbp/installment', this.installmentFormData)
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }

      this.sendingData = false
    },
  },
  components: {
    installmenttableVue,
  },
}
</script>